
import BaseUrl from './base-uri.json'
import axios from 'axios';
import { getToken } from './Token';
import { getGlobalClientId } from './Token';
import { ToastContainer, toast } from "react-toastify";
import { setExpiredSec } from './Token';
// const axios = require('axios');

// Step-1: Create a new Axios instance with a custom config.
// The timeout is set to 10s. If the request takes longer than
// that then the request will be aborted.
const fvAxios = axios.create({
    baseURL: BaseUrl.baseUrl,
    //baseURL: `${process.env.APP_URL}`,
    timeout: 60 * 10000,
    headers: BaseUrl.apiHeaders.headers
});

// Step-2: Create request, response & error handlers
const requestHandler = request => {
    // Token will be dynamic so we can use any app-specific way to always   
    // fetch the new token before making the call
    if (getToken())
        request.headers.Authorization = 'Bearer ' + getToken();
    request.headers.ClientIDs = getGlobalClientId();
    return request;
};

const responseHandler = response => {
    if (response.status === 401) {

        window.location = '/';
    }

    return response;
};

const errorHandler = error => {
    if (error.response?.status === 401) {
        //alert("Session Expired!! Please login again.")
        setExpiredSec("1");
        window.location = '/';
    }

    return Promise.reject(error);

};

// Step-3: Configure/make use of request & response interceptors from Axios
// Note: You can create one method say configureInterceptors, add below in that,
// export and call it in an init function of the application/page.
fvAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

fvAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
);


// Step-4: Export the newly created Axios instance to be used in different locations.

export default fvAxios